import React from "react";
import { Grid } from "@mui/material";

const CounterCard = (props) => {
    return(
        <Grid
            xs={12}
            sm={6}
            md={3}
            className={props.customClass}
        >
            <h4 className="mb-3">{props.counterNumber}</h4>
            <p className="mb-0">{props.subtitle}</p>
        </Grid>
    )
}

export default CounterCard;